import { formatChord } from '../model/chord';
import type { Platform } from '../model/keybindingTypes';

/**
 * Plan D4 non-goals: what this tab cannot rebind, and the one cost of binding
 * a chord that the SQL editor also uses.
 */
export function KeybindingsFooter({ platform }: { readonly platform: Platform }) {
  const keys = (...chords: string[]) => chords.map((chord) => formatChord(chord, platform)).join(', ');
  return (
    <div className="space-y-2 border-t border-border pt-3 text-xs text-muted-foreground" data-testid="keybindings-footer">
      <p>
        <span className="font-medium text-foreground">Not changeable here:</span> the SQL editor&rsquo;s editing
        shortcuts ({keys('Mod+/', 'Mod+D', 'Alt+ArrowUp', 'Mod+F')}, …), Notebook command-mode letters (M, Y, A, B,
        DD), {keys('Mod+C')} and Escape in the results grids, the arrow keys in the tab strip, and the app menu&rsquo;s
        built-in items such as Copy, Paste, Undo, Minimize and Quit.
      </p>
      <p>
        A shortcut that runs while the SQL editor has focus takes over the editor&rsquo;s own use of those keys.
        For example {keys('Mod+Enter')} runs the current statement instead of inserting a line below, and
        {' '}{keys('Shift+Enter')} runs it instead of inserting a newline.
      </p>
    </div>
  );
}
